import { render, staticRenderFns } from "./rectification.vue?vue&type=template&id=1a5f0a5a&"
import script from "./rectification.vue?vue&type=script&lang=js&"
export * from "./rectification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports